import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { StandardDialog, Button } from '@roc/ui';
import { ExpectedWireReleaseDate } from './expectedWireReleaseDate';
import { ExpectedWireReleaseDateStore } from '../../../stores/documentForms/expectedWireReleaseDateStore';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { WithDocumentActions } from '../../..';

export type ExpectedWireReleaseDateDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loanId: string;
  store: ExpectedWireReleaseDateStore;
  document: Document;
};

export const ExpectedWireReleaseDateDialog = (
  props: ExpectedWireReleaseDateDialogProps
) => {
  const { open, onClose, loanId, store, document } = props;
  const taskId = document?.taskId;

  const onSubmit = () => {
    store.submitexpectedWireReleaseDateState();
    if (!onClose) return;
    onClose();
  };

  const getActions = () => {
    return (
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <WithDocumentActions
            document={document}
            component={Button}
            onClick={onSubmit}
            color="primary"
            variant="contained"
            testId="confirm"
            disabled={!store.shouldBeAbleToSubmitExpectedWireReleaseDate()}
          >
            Submit
          </WithDocumentActions>
        </Grid>
      </Grid>
    );
  }

  const getContent = () => {
    return (
      <Grid container spacing={4}>
        <Grid item md={12}>
          <ExpectedWireReleaseDate store={store} />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Expected Wire Release Date"
          handleClose={onClose}
          dialogContent={getContent()}
          dialogActions={getActions()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Expected Wire Release Date"
          maxWidth="xs"
          handleClose={onClose}
          dialogContent={<ExpectedWireReleaseDate store={store} />}
          dialogActions={getActions()}
        />
      )}
    </>
  );
};

export default ExpectedWireReleaseDateDialog;
